import * as React from 'react'
import Box from '@mui/joy/Box'
import Chip from '@mui/joy/Chip'
import Tooltip from '@mui/joy/Tooltip'
import { DocumentJobAttempt } from '@numeo/types-core'
import { formatToUserLocalTime } from '@/utils/date-formatting'

/** `OCR · local · local-ocr · ✓`: which stage, where it ran, with what, and whether it delivered. */
function attemptLabel(attempt: DocumentJobAttempt): string {
    return `${attempt.stage} · ${attempt.where} · ${attempt.reader} · ${attempt.ok ? '✓' : '✗'}`
}

function attemptDetail(attempt: DocumentJobAttempt): string {
    const parts = [attempt.device ? `on ${attempt.device}` : null, attempt.ok ? 'delivered' : `not delivered: ${attempt.reason ?? 'no reason given'}`]
    return `${parts.filter(Boolean).join(', ')} · ${formatToUserLocalTime(attempt.at)}`
}

/**
 * Every worker's try at a job, oldest first. The tries that delivered are solid; the ones that did not are muted, with the
 * reason on hover, so a job that went through several workers shows each of them.
 */
export function AttemptTags({ attempts }: { attempts: DocumentJobAttempt[] }) {
    if (!attempts.length) return <>--</>
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {attempts.map((attempt, i) => (
                <Tooltip key={i} title={attemptDetail(attempt)}>
                    <Chip
                        size="sm"
                        variant={attempt.ok ? 'solid' : 'outlined'}
                        color={attempt.ok ? 'success' : 'neutral'}
                        sx={attempt.ok ? undefined : { opacity: 0.7 }}
                    >
                        {attemptLabel(attempt)}
                    </Chip>
                </Tooltip>
            ))}
        </Box>
    )
}
